import * as S from "./styles";

interface IPercentageProps {
	percentage: number;
}
/**
 * @description - Component to show a percentage
 * @param percentage - percentage of the progress bar 0 to 100
 * @returns
 */
function Percentage({ percentage }: IPercentageProps) {
	const formattedPercentage = `${percentage.toFixed(2)}%`;
	const decimalPercentage = percentage / 100;

	return (
		<S.Container>
			<S.ContainerPercentage>
				<S.Percentage $numberPercentage={formattedPercentage} $decimalPercentage={decimalPercentage}>
					{formattedPercentage}
				</S.Percentage>
			</S.ContainerPercentage>
		</S.Container>
	);
}

export default Percentage;
